import React from 'react';
import { Switch, Tooltip } from '@cambridgeassessment/cambridge-ui';
import { ComponentResubmissionToggleSpan } from './ComponentCard.styles';

type SwitchProps = {
  onChange: (value: boolean) => void;
  checked: boolean;
  disabled: boolean;
  title: string;
};

const SelectAllSwitch: React.FC<SwitchProps> = ({ onChange, checked, disabled, title }) => {
  return (
    <Tooltip arrow={true} placement='top-start' dataQaId={'toggle-all-replacement'} title={title}>
      <ComponentResubmissionToggleSpan>
        Select all
        <Switch dataQaId={'toggle-all-switch'} checked={checked} onChange={onChange} disabled={disabled} />
      </ComponentResubmissionToggleSpan>
    </Tooltip>
  );
};

export default SelectAllSwitch;
